import { type ReactNode } from "react";

/**
 * A labeled band of the dashboard. The page groups its cards into three of
 * these — Reveshare, Shopify, TikTok Shop — so each figure reads inside the
 * world it belongs to instead of everything sharing one bag. The header is
 * a divider + icon chip + title/description, deliberately quieter than the
 * cards themselves.
 */
export function DashboardSection({
  id,
  icon,
  title,
  description,
  badge,
  children,
}: {
  /** Anchor the sticky dashboard nav scrolls to. */
  id?: string;
  icon: ReactNode;
  title: string;
  description: string;
  /** Floats just past the end of the title, raised (e.g. a Beta badge). */
  badge?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section id={id} className="scroll-mt-36 space-y-4">
      <div className="flex items-center gap-3 border-t border-border pt-5">
        <div className="flex size-9 shrink-0 items-center justify-center rounded-lg border border-border bg-card">
          {icon}
        </div>
        <div className="min-w-0 flex-1">
          <h2 className="text-base font-semibold text-foreground">
            <span className="relative inline-block">
              {title}
              {badge ? (
                <span className="pointer-events-none absolute -top-2 left-full ml-2 z-10">{badge}</span>
              ) : null}
            </span>
          </h2>
          <p className="text-sm text-muted-foreground">{description}</p>
        </div>
      </div>
      {children}
    </section>
  );
}
